import { render, staticRenderFns } from "./deviceBuild.vue?vue&type=template&id=8c696d30&scoped=true&"
import script from "./deviceBuild.vue?vue&type=script&lang=js&"
export * from "./deviceBuild.vue?vue&type=script&lang=js&"
import style0 from "./deviceBuild.vue?vue&type=style&index=0&id=8c696d30&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c696d30",
  null
  
)

export default component.exports